export const THEMES = {
  blue: "palletThemeBlue",
  dark: "palletThemeDark",
};
